import { render, staticRenderFns } from "./ViDatePicker.vue?vue&type=template&id=79d2cd9d&"
import script from "./ViDatePicker.vue?vue&type=script&lang=js&"
export * from "./ViDatePicker.vue?vue&type=script&lang=js&"
import style0 from "./ViDatePicker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports